import type { AdminStudioPendingReason, AdminStudioSeatGrantResult } from '@/api/adminClient';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isEmailAddress(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

const INVITE_REASONS: Record<AdminStudioPendingReason, string> = {
  no_account: 'they have no login yet',
  not_verified: "they haven't verified their email",
  ambiguous_account: 'more than one login uses this address',
  directory_unavailable: 'their login could not be looked up',
};

export type AddPersonOutcome = { label: string; result?: AdminStudioSeatGrantResult; error?: string };

/** What happened to everyone in one "Add people", in the order the admin reads it. */
export function summarizeAddPeople(outcomes: AddPersonOutcome[]): { added: string; invited: string[]; failed: string[] } {
  const added = outcomes.filter((outcome) => outcome.result?.seat).length;
  const invited = outcomes
    .filter((outcome) => outcome.result?.pendingGrant)
    .map((outcome) => {
      const reason = outcome.result?.reason;
      const why = reason && Object.hasOwn(INVITE_REASONS, reason) ? INVITE_REASONS[reason] : 'they have no login yet';
      return `Invited ${outcome.label}: ${why}, so access starts at their first sign-in`;
    });
  const failed = outcomes.filter((outcome) => outcome.error).map((outcome) => `${outcome.label}: ${outcome.error}`);
  return { added: added === 0 ? '' : added === 1 ? 'Added 1 person' : `Added ${added} people`, invited, failed };
}
